import React from "react";
import "./FaultFirstPageCustom_Coral.css";
import * as $ from "jquery";
import { useState, useRef } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  INIT_STATE_SELECTS,
  INDEX,
} from "../../../../constants/driveglobalfilterinitialstates_coral";
import CustomSelect_Coral from "./CustomSelect_Coral";
import { BsFillSkipForwardBtnFill } from "react-icons/bs";

export default function FaultFirstPageFilters_Coral(props) {
 const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [singleBtn, setsingleBtn] = useState(false);
  const inputElement = useRef();
  const socref = useRef();

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  };
console.log('filters');
  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];
    setFilterData((prestate) => {
      return { ...filterdata, [state_ind]: arr };
    });
    setChangedColumn(index);
    if (columnfilters.indexOf(index) == -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  };

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    if (enterter_vin != "") {
      let new_vin = enterter_vin.split(",");
      if (new_vin.length == 1) {
        setsingleBtn(true);
      }
      setChangedColumn("VIN_NUM");
      let VIN_NUM = "VIN_NUM";
      setFilterData((prestate) => {
        return { ...filterdata, VIN_NUM: new_vin };
      });
      if (columnfilters.indexOf("VIN_NUM") == -1) {
        setcolumnfilters([...columnfilters, "VIN_NUM"]);
      }
    }
  };

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => {
      return { ...filterdata, [sDate]: date };
    });
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  };

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => {
      return { ...filterdata, [eDate]: date };
    });
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  };

  const changeSoc = (e) => {
    setChangedColumn("SOC_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, SOC: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("SOC_INDEX") == -1) {
      setcolumnfilters([...columnfilters, "SOC_INDEX"]);
    }
  };

  const onsubmit = (e) => {
    e.preventDefault();
    props.onsubmit(filterdata);
  };

  const onreset = (e) => {
    e.preventDefault();
    setFilterData(INIT_STATE_SELECTS);
    setcolumnfilters([]);
    setChangedColumn("");
    inputElement.current.value = "";
    props.onreset(INIT_STATE_SELECTS);
  };

  const secondPageCilcked = () => {
    props.onsubmit({ ...filterdata, pageSelected: 2 });
  };

  let count = 0;
  const showblock = () => {
    if (count === 0) {
      $("#filterSearch").css("display", "block");
      count = 1;
    } else {
      $("#filterSearch").css("display", "none");

      count = 0;
    }
  };

  return (
    <div className="container-fluid mainDiv">
      <div className="text-end ev-auto">
        <button
          type="button"
          id="filterIcon"
          className="btn btn-outline-primary material-icons ev_filter_icon"
          onClick={filterHideShow}
        >
          filter_alt
        </button>
      </div>
      <div
        className="bg-light  FilterDiv p-3  mb-3"
        id="filterSearch"
        style={{ display: "none", zIndex: 1 }}
      >
        {/* Filters area here */}
        {/* Filter Form Starts */}
        <form className="row g-3 mt-2 filterForm">
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="select_col_title"
                >
                  Start Date
                </label>
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  minDate={moment(
                    new Date("2022-07-01T00:00:00.000Z")
                  ).toDate()}
                  maxDate={moment().subtract(1, "days").toDate()}
                  selected={filterdata.startDate}
                  onChange={startDateChanged}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="select_col_title"
                >
                  End Date
                </label>
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  minDate={moment(
                    new Date("2022-07-01T00:00:00.000Z")
                  ).toDate()}
                  maxDate={moment().subtract(1, "days").toDate()}
                  selected={filterdata.endDate}
                  onChange={endDateChanged}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="select_col_title"
                >
                  Vin No / Chassis No
                </label>
                <input
                  autoComplete="off"
                  defaultValue={filterdata.VIN_NUM.join(",")}
                  className="top-filter filter-col"
                  placeholder="Vin No / Chassis No"
                  id="vin_num"
                  ref={inputElement}
                  onBlur={vinnumChanged}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect_Coral
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="CITY"
                  IND="CITY_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect_Coral>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect_Coral
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="LOB"
                  IND="LOB_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect_Coral>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect_Coral
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="PPL"
                  IND="PPL_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect_Coral>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect_Coral
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="PL"
                  IND="PL_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect_Coral>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mt-3">
                <label htmlFor className="form-label" />
                <button
                  type="submit"
                  className="form-control btn btn-primary"
                  onClick={onsubmit}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mt-3">
                <label htmlFor className="form-label" />
                <button
                  type="submit"
                  className="form-control btn btn-secondary"
                  onClick={onreset}
                >
                  Reset
                </button>
              </div>
            </div>
            
            {singleBtn && (
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mt-3">
                  <label htmlFor className="form-label" />
                  <button
                    className="form-control btn  btn-primary"
                    onClick={secondPageCilcked}
                  >
                    <BsFillSkipForwardBtnFill />
                  </button>
                </div>
              </div>
            )}
          </div>
        </form>
        {/* Filter Form Ends */}
      </div>
    </div>
  );
}
